var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSplashDots1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 360,
  height: 336,
  fill: "none",
  viewBox: "0 0 360 336"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M170 42a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M170 14a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M140 42a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M140 14a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M110 42a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M110 14a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  d: "M200 42a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  d: "M170 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  d: "M170 70a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#j)",
  d: "M140 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#k)",
  d: "M140 70a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#l)",
  d: "M110 70a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#m)",
  d: "M230 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#n)",
  d: "M230 70a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#o)",
  d: "M200 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#p)",
  d: "M200 70a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#q)",
  d: "M350 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#r)",
  d: "M320 98a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#s)",
  d: "M80 154a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#t)",
  d: "M170 154a5 5 0 1 0-10.001.001A5 5 0 0 0 170 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#u)",
  d: "M140 154a5 5 0 1 0-10.001.001A5 5 0 0 0 140 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#v)",
  d: "M110 154a5 5 0 1 0-10.001.001A5 5 0 0 0 110 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#w)",
  d: "M260 154a5 5 0 1 0-10.001.001A5 5 0 0 0 260 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#x)",
  d: "M260 126a5 5 0 1 0-10.001.001A5 5 0 0 0 260 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#y)",
  d: "M230 154a5 5 0 1 0-10.001.001A5 5 0 0 0 230 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#z)",
  d: "M230 126a5 5 0 1 0-10.001.001A5 5 0 0 0 230 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#A)",
  d: "M200 154a5 5 0 1 0-10.001.001A5 5 0 0 0 200 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#B)",
  d: "M200 126a5 5 0 1 0-10.001.001A5 5 0 0 0 200 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#C)",
  d: "M350 126a5 5 0 1 0-10.001.001A5 5 0 0 0 350 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#D)",
  d: "M320 154a5 5 0 1 0-10.001.001A5 5 0 0 0 320 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#E)",
  d: "M320 126a5 5 0 1 0-10.001.001A5 5 0 0 0 320 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#F)",
  d: "M290 154a5 5 0 1 0-10.001.001A5 5 0 0 0 290 154"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#G)",
  d: "M290 126a5 5 0 1 0-10.001.001A5 5 0 0 0 290 126"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#H)",
  d: "M80 210a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#I)",
  d: "M80 182a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#J)",
  d: "M50 210a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#K)",
  d: "M50 182a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#L)",
  d: "M20 210a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#M)",
  d: "M170 210a5 5 0 1 0-10.001.001A5 5 0 0 0 170 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#N)",
  d: "M170 182a5 5 0 1 0-10.001.001A5 5 0 0 0 170 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#O)",
  d: "M140 210a5 5 0 1 0-10.001.001A5 5 0 0 0 140 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#P)",
  d: "M140 182a5 5 0 1 0-10.001.001A5 5 0 0 0 140 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Q)",
  d: "M110 210a5 5 0 1 0-10.001.001A5 5 0 0 0 110 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#R)",
  d: "M110 182a5 5 0 1 0-10.001.001A5 5 0 0 0 110 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#S)",
  d: "M260 210a5 5 0 1 0-10.001.001A5 5 0 0 0 260 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#T)",
  d: "M260 182a5 5 0 1 0-10.001.001A5 5 0 0 0 260 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#U)",
  d: "M230 210a5 5 0 1 0-10.001.001A5 5 0 0 0 230 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#V)",
  d: "M230 182a5 5 0 1 0-10.001.001A5 5 0 0 0 230 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#W)",
  d: "M200 210a5 5 0 1 0-10.001.001A5 5 0 0 0 200 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#X)",
  d: "M200 182a5 5 0 1 0-10.001.001A5 5 0 0 0 200 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Y)",
  d: "M290 210a5 5 0 1 0-10.001.001A5 5 0 0 0 290 210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Z)",
  d: "M290 182a5 5 0 1 0-10.001.001A5 5 0 0 0 290 182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#aa)",
  d: "M80 266a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ab)",
  d: "M80 238a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ac)",
  d: "M50 266a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ad)",
  d: "M50 238a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ae)",
  d: "M20 266a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#af)",
  d: "M20 238a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ag)",
  d: "M170 266a5 5 0 1 0-10.001.001A5 5 0 0 0 170 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ah)",
  d: "M170 238a5 5 0 1 0-10.001.001A5 5 0 0 0 170 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ai)",
  d: "M140 266a5 5 0 1 0-10.001.001A5 5 0 0 0 140 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#aj)",
  d: "M140 238a5 5 0 1 0-10.001.001A5 5 0 0 0 140 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ak)",
  d: "M110 266a5 5 0 1 0-10.001.001A5 5 0 0 0 110 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#al)",
  d: "M110 238a5 5 0 1 0-10.001.001A5 5 0 0 0 110 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#am)",
  d: "M350 266a5 5 0 1 0-10.001.001A5 5 0 0 0 350 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#an)",
  d: "M350 238a5 5 0 1 0-10.001.001A5 5 0 0 0 350 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ao)",
  d: "M320 266a5 5 0 1 0-10.001.001A5 5 0 0 0 320 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ap)",
  d: "M320 238a5 5 0 1 0-10.001.001A5 5 0 0 0 320 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#aq)",
  d: "M290 266a5 5 0 1 0-10.001.001A5 5 0 0 0 290 266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ar)",
  d: "M290 238a5 5 0 1 0-10.001.001A5 5 0 0 0 290 238"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#as)",
  d: "M80 322a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#at)",
  d: "M80 294a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#au)",
  d: "M50 322a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#av)",
  d: "M50 294a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#aw)",
  d: "M20 294a5 5 0 1 0-10 0 5 5 0 0 0 10 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ax)",
  d: "M140 294a5 5 0 1 0-10.001.001A5 5 0 0 0 140 294"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ay)",
  d: "M110 322a5 5 0 1 0-10.001.001A5 5 0 0 0 110 322"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#az)",
  d: "M110 294a5 5 0 1 0-10.001.001A5 5 0 0 0 110 294"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#aA)",
  d: "M320 294a5 5 0 1 0-10.001.001A5 5 0 0 0 320 294"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "o",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "p",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "q",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "r",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "t",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "u",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "v",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "w",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "B",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "C",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "D",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "E",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "F",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "G",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "H",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "I",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "J",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "K",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "L",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "M",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "N",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "O",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "P",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Q",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "R",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "S",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "T",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "U",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "V",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "W",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "X",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Y",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Z",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aa",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ab",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ac",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ad",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ae",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "af",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ag",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ah",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ai",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aj",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ak",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "al",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "am",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "an",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ao",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ap",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aq",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ar",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "as",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "at",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "au",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "av",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aw",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ax",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ay",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "az",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aA",
  x1: 180,
  x2: 180,
  y1: 9,
  y2: 327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B4FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B4FF"
})))));
export { SvgSplashDots1 as ReactComponent };
export default __webpack_public_path__ + "static/splash-dots-1.db18f426.svg";